// src/router/index.js

import Vue from 'vue'
import VueRouter from 'vue-router'
import { authService } from '../services/auth'

// Import components
import Login from '@/components/loginPage.vue'
import UserDetails from '@/components/UserDetails.vue'
import CreateLead from '@/components/CreateLead.vue'
import SubscriptionChange from '@/components/subscriptionChange.vue'
import UpdateCard from '@/components/UpdateCard.vue'
import UserReviewInvitations from '@/components/UserReviewInvitations.vue'

import HomePage from '@/components/HomePage.vue'



Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'HomePage',
    component: HomePage,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/login',
    name: 'login',
    component: Login,
    meta: {
      guest: true
    }
  },
  {
    path: '/users/:id',
    name: 'userDetails',
    component: UserDetails,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/create-lead',
    name: 'createLead',
    component: CreateLead,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/save-customer/:id',
    name: 'saveCustomer',
    component: SubscriptionChange,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/update-card/:id',
    name: 'updateCard',
    component: UpdateCard,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/review-invitations',
    name: 'reviewInvitations',
    component: UserReviewInvitations,
    meta: {
      requiresAuth: true
    }
  },
  {
    path: '/review-invitations/:id',
    name: 'reviewInvitationsWithUser',
    component: UserReviewInvitations,
    meta: {
      requiresAuth: true
    }
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// Navigation guard
router.beforeEach((to, from, next) => {
  const isLoggedIn = authService.isLoggedIn()
  
  // Route requires authentication
  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!isLoggedIn) {
      // Redirect to login page with return URL
      next({
        path: '/login',
        query: { redirect: to.fullPath }
      })
    } else {
      next()
    }
  } 
  // Route is for guests only (like login)
  else if (to.matched.some(record => record.meta.guest)) {
    if (isLoggedIn) {
      // Redirect to home if already logged in
      next({ name: 'home' })
    } else {
      next()
    }
  } 
  // Public route
  else {
    next()
  }
})

export default router